/* eslint-disable react/no-unknown-property */
import React from 'react';

import { Grid, Stack, Typography } from '@mui/material';
import { Bank, DiscordLogo, MediumLogo, TwitterLogo } from 'phosphor-react';

import { NormalLink } from '~components/shared/link';
import { primaryColors } from '~components/theme/styles/colors';
import { secondaryBox } from '~components/theme/styles/mixins';
import { ENativeAsset } from '~config/types';

import { AssetIcon } from '../../ui/icons/assets';

import SlideWrapper from './SlideWrapper';

function EngagementSlide() {
  const stackBaseProps = {
    alignItems: { xs: 'center', sm: 'start' },
    direction: { xs: 'row', sm: 'column' },
    spacing: 2,
    sx: secondaryBox,
  } as any;
  return (
    <SlideWrapper
      sx={{
        justifyContent: 'center',
        overflow: 'hidden',
        mb: 40,
      }}
    >
      <Typography variant={'h4'} mt={4}>
        Join the Vesta Community
      </Typography>
      <Grid container direction={'row'} justifyContent={'start'} textAlign={'left'} spacing={4} mt={4}>
        <Grid item xs={12} sm={4}>
          <NormalLink sx={{ textDecoration: 'none' }}>
            <Stack {...stackBaseProps}>
              <TwitterLogo size={38} />
              <Typography variant={'h6'} color={primaryColors[100]}>
                Twitter
              </Typography>
            </Stack>
          </NormalLink>
        </Grid>
        <Grid item xs={12} sm={4}>
          <NormalLink sx={{ textDecoration: 'none' }}>
            <Stack {...stackBaseProps}>
              <MediumLogo size={38} />
              <Typography variant={'h6'} mt={2} color={primaryColors[100]}>
                Medium
              </Typography>
            </Stack>
          </NormalLink>
        </Grid>
        <Grid item xs={12} sm={4}>
          <NormalLink sx={{ textDecoration: 'none' }}>
            <Stack {...stackBaseProps}>
              <DiscordLogo size={38} />
              <Typography variant={'h6'} mt={2} color={primaryColors[100]}>
                Discord
              </Typography>
            </Stack>
          </NormalLink>
        </Grid>
      </Grid>

      <Typography variant={'h4'} mt={20}>
        Engage in Vesta’s Governance
      </Typography>
      <Grid container direction={'row'} justifyContent={'start'} textAlign={'left'} spacing={4} mt={4}>
        <Grid item xs={12} sm={6}>
          <NormalLink sx={{ textDecoration: 'none' }}>
            <Stack direction={'row'} alignItems={'center'} spacing={2} sx={{ ...secondaryBox }}>
              <Bank size={38} />
              <Typography variant={'base'} mt={2} color={primaryColors[100]}>
                Check out Curia, our Governance Forum!
              </Typography>
            </Stack>
          </NormalLink>
        </Grid>
        <Grid item xs={12} sm={6}>
          <NormalLink sx={{ textDecoration: 'none' }}>
            <Stack direction={'row'} alignItems={'center'} spacing={2} sx={{ ...secondaryBox }}>
              <AssetIcon noBg noBorder asset={ENativeAsset.VSTA} size={38} />
              <Typography variant={'base'} mt={2} color={primaryColors[100]}>
                Read our Documentation & White Paper!
              </Typography>
            </Stack>
          </NormalLink>
        </Grid>
      </Grid>
    </SlideWrapper>
  );
}

export default EngagementSlide;
